import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { selectors as apiSelectors } from 'lp-redux-api';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { compose } from 'redux';
import { WIZARD_URL } from 'shared';
import * as actions from '../actions';
import { Card as PracticeCard, PracticeSearchInput } from '../components';
import { selectors } from '../reducer';
function Practice({ setPractice, practicesList, loading, setPracticesList, }) {
    const history = useHistory();
    const handlePracticeSelection = (practice) => {
        setPractice(practice);
        history.push(WIZARD_URL);
    };
    useEffect(() => {
        return () => {
            setPracticesList(null);
        };
    }, []);
    return (_jsx(_Fragment, { children: _jsxs("div", { className: "practice-content", children: [_jsx("p", { className: "practice", children: "Select Your Practice" }), _jsx(PracticeSearchInput, { searchPromptText: "SEARCH AGAIN", withBackButton: true }), _jsx("div", { className: "practice-result", children: !loading && (_jsxs(_Fragment, { children: [practicesList ? (_jsx(PracticeCard, { practice: practicesList, onPracticeSelection: handlePracticeSelection })) : (_jsx("p", { className: "found-result", children: "We found 0 results." })), _jsx("p", { className: "cannot-found", children: "Can't find your provider?" }), _jsx("p", { className: "cannot-found-content", children: "Alphaeon Credit will happily contact your doctor about enrolling in the program." })] })) })] }) }));
}
function mapStateToProps(state) {
    return {
        practicesList: selectors.practicesList(state),
        loading: apiSelectors.isLoading(state, 'PRACTICE_DATA'),
    };
}
const mapDispatchToProps = {
    setPractice: actions.setPractice,
    setPracticesList: actions.setPracticesList,
};
export default compose(connect(mapStateToProps, mapDispatchToProps))(Practice);
